import { useContext } from 'react'
import { SnippetsGridContext } from './SnippetsContainer'
import { Flex } from '@chakra-ui/react'

export const SnippetsContainerRightAside = ({ children, ...props }) => {
  const { windowHeight, indentTop } = useContext(SnippetsGridContext)
  return (
    <Flex
      overflowX="hidden"
      overflowY="auto"
      flexDirection="column"
      height={`${windowHeight - indentTop}px`}
      {...props}
    >
      {children}
    </Flex>
  )
}
